import { dataIdCardBackSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdCardBackSolid = /*#__PURE__*/createIcon(dataIdCardBackSolid)
export default IconIdCardBackSolid
